import styled from '@emotion/styled';

const UserSearchInputWrapper = styled('span')({
  display: 'flex',
  alignItems: 'center',
});

export default UserSearchInputWrapper;
